import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const MantenimientoCorrectivo = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/ingenieria-mantenimiento-correctivo.pdf`;
  /*const pdfUrl = "/pdf/ingenieria-mantenimiento-correctivo.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Mentenimiento Correctivo</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Mentenimiento Correctivo" />
      </Container>
    </>
  );
};

 export default MantenimientoCorrectivo;
